import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';
@Pipe({
  standalone: false, name: 'amDateFormat' })
export class AmDateFormatPipe implements PipeTransform {
 transform(value: any, format: string = 'MMM D, YYYY'): string {
   if (!value) return '';
   return dayjs(value).format(format);
 }
}